<script setup>
import { CloudIcon, ShieldCheckIcon, UserCircleIcon } from '@heroicons/vue/24/outline'

const features = [
    {
        icon: CloudIcon,
        title: 'Digitálně i klasicky',
        description: 'Nahrajte fotku do cloudu nebo se stavte osobně.',
    },
    {
        icon: ShieldCheckIcon,
        title: 'Garantovaná správnost',
        description: 'Naše práce je pojištěna. Za výsledky ručíme.',
    },
    {
        icon: UserCircleIcon,
        title: 'Individuální péče',
        description: 'Osobitý přístup je pro nás prioritou.',
    },
]
</script>

<template>
    <section
        class="bg-white pb-20 md:pb-28"
        id="services"
    >
        <div class="mx-auto max-w-7xl px-6 lg:px-10">
            <div class="grid gap-6 md:grid-cols-3 md:gap-8">
                <article
                    class="rounded-2xl bg-zinc-100/70 p-8 md:p-10"
                    v-for="feature in features"
                    :key="feature.title"
                >
                    <div class="text-brand-900 flex size-12 items-center justify-center rounded-lg bg-white">
                        <component
                            class="size-7"
                            :is="feature.icon"
                            stroke-width="1.5"
                        />
                    </div>

                    <h3 class="text-brand-900 mt-10 text-2xl font-extrabold tracking-tight md:text-3xl">
                        {{ feature.title }}
                    </h3>

                    <p class="mt-5 text-base leading-relaxed text-zinc-600">
                        {{ feature.description }}
                    </p>
                </article>
            </div>
        </div>
    </section>
</template>
